import React, { lazy, Suspense } from 'react';
import { Alert } from 'antd';
import I18n from 'i18n-js';
import CWOConfigProvider from 'helpers/cwoConfigProvider';
import Loading from 'helpers/loading/loading';

const Component = lazy(async () => {
  const { CropsIndex } = await import('components/crops-index');
  return { default: CropsIndex };
});

const CropsIndex = (props) => (
  <CWOConfigProvider>
    <Alert.ErrorBoundary title={I18n.t('errors.something_when_wrong')} description="">
      <Suspense fallback={<Loading />}>
        <Component {...props} />
      </Suspense>
    </Alert.ErrorBoundary>
  </CWOConfigProvider>
);

export default CropsIndex;
